export async function getLinkToken(token) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/link-token/`, {
      method: "GET",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      })
    });
    const response_obj  = await response.json()
    
    return response_obj.linkToken;
  } catch (error) {
    return {};
  }
}

export async function passPublicToken(token, accountId, publicToken) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/link-exchange/`, {
      method: "POST",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify({
        account: accountId,
        public_token: publicToken
      })
    });
    return response
  } catch (error) {
    return {};
  }

}

export async function getVesselConnections(token, accountId) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/connection/?account=${accountId}`, {
      method: "GET",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      })
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function createVesselRule(token, accountId, ruleBody) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/rule/?account=${accountId}`, {
      method: "POST",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify(ruleBody)
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function deleteVesselRule(token, accountId, ruleBody) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/rule/?account=${accountId}`, {
      method: "DELETE",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify(ruleBody)
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function editVesselRule(token, accountId, ruleBody) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/rule/?account=${accountId}`, {
      method: "PATCH",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify(ruleBody)
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function deleteVesselConnection(token, accountId, connectionId) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/connection/?account=${accountId}`, {
      method: "DELETE",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify({
        connectionId: connectionId
      })
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function editVesselProperties(token, accountId, propertyBody) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/properties/?account=${accountId}`, {
      method: "PATCH",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify(propertyBody)
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function createVesselProperties(token, accountId, propertyBody) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/properties/?account=${accountId}`, {
      method: "POST",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      }),
      body: JSON.stringify(propertyBody)
    });
    return response
  } catch (error) {
    return {};
  }
}

export async function updateVesselProperties(token, accountId, connection_id) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vessel/properties/?account=${accountId}&connection_id=${connection_id}`, {
      method: "GET",
      headers: new Headers({
        Authorization: token,
        Accept: "application/json",
      })
    });
    return response
  } catch (error) {
    return {};
  }
}